import { Button, Dropdown, Flex, Progress, Table, Tag, Tooltip } from "antd";
import React, { useState } from "react";
import { formatDateTime } from "../../../utilities/utils";
import { IconAlertSquareRounded, IconArrowRight } from "@tabler/icons-react";
import api from "../../../api";
import { useToast } from "../../../components/toast/toast";
import CustomModal from "../../../components/modal/CustomModal";
import CustomTextarea from "../../../components/input/CustomTextarea";

const MassSmsTable = ({ data, loading, pagination, handleTableChange }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [description, setDescription] = useState("");
  const toast = useToast();

  const columns = [
    { title: "Гарчиг", dataIndex: "title", key: "title" },
    {
      title: "Дугаарын тоо",
      dataIndex: ["info", "count"],
      key: "count",
      render: (val) => val || "-",
    },
    {
      title: "Төлөв",
      key: "stats",
      render: (_, record) => {
        const info = record.info || {};
        return (
          <Tooltip
            title={
              <div style={{ fontSize: 11 }}>
                <div>
                  Send:{" "}
                  <span
                    style={{
                      display: "inline-block",
                      background: "#52c41a",
                      width: 8,
                      height: 8,
                      marginLeft: 4,
                    }}
                  />
                </div>
                <div>
                  Failed:{" "}
                  <span
                    style={{
                      display: "inline-block",
                      background: "#ff4d4f",
                      width: 8,
                      height: 8,
                      marginLeft: 4,
                    }}
                  />
                </div>
                <div>
                  Canceled:{" "}
                  <span
                    style={{
                      display: "inline-block",
                      background: "#999",
                      width: 8,
                      height: 8,
                      marginLeft: 4,
                    }}
                  />
                </div>
              </div>
            }
          >
            <div
              style={{
                display: "flex",
                gap: "8px",
                fontWeight: 600,
                color: "#ddd",
              }}
            >
              <span style={{ color: "#52c41a" }}>{info.sent ?? 0}</span>/
              <span style={{ color: "#ff4d4f" }}>{info.failed ?? 0}</span>/
              <span style={{ color: "#999" }}>{info.canceled ?? 0}</span>
            </div>
          </Tooltip>
        );
      },
    },
    // {
    //   title: "Илгээгдсэн",
    //   dataIndex: ["info", "sent"],
    //   key: "sent",
    //   render: (val) => val ?? "-",
    // },
    // {
    //   title: "Амжилтгүй",
    //   dataIndex: ["info", "failed"],
    //   key: "failed",
    //   render: (val) => val ?? "-",
    // },
    // {
    //   title: "Цуцлагдсан",
    //   dataIndex: ["info", "canceled"],
    //   key: "canceled",
    //   render: (val) => val ?? "-",
    // },
    {
      title: "Мессеж",
      key: "message",
      render: (_, record) => record.info?.message || "-",
    },
    { title: "Үүсгэсэн админ", dataIndex: "user_email", key: "user_email" },
    {
      title: "Илгээх огноо",
      dataIndex: "started_at",
      key: "started_at",
      render: (text) => (text ? formatDateTime(text) : "-"),
    },
    {
      title: "Үйлдэл",
      key: "actions",
      width: 150,
      render: (_, record) => {
        const items = [
          {
            key: "cancel",
            label: (
              <span style={{ color: "red", fontSize: "13px" }}>Цуцлах</span>
            ),
          },
        ];

        return record.ended_at && record.comment ? (
          <Tooltip
            title={
              <div style={{ maxWidth: 360, whiteSpace: "pre-wrap" }}>
                <div style={{ fontWeight: 500, marginBottom: 6 }}>
                  Тайлбар:{" "}
                  <span style={{ fontWeight: 600 }}>{record.comment}</span>
                </div>
                <div style={{ fontSize: 12, opacity: 0.8 }}>
                  Цуцалсан цаг: {formatDateTime(record.ended_at)}
                </div>
              </div>
            }
            placement="topLeft"
          >
            <Tag color="red" style={{ cursor: "help" }}>
              Цуцалсан
            </Tag>
          </Tooltip>
        ) : (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "cancel") {
                  // console.log("Цуцлах:", record);
                  setSelectedData(record);
                  setShowModal(true);
                }
                // setSelectedData(record);
              },
            }}
            trigger={["click"]}
          >
            <Button
              variant="filled"
              color="default"
              style={{ padding: "0 20px", fontSize: "12px" }}
            >
              Үйлдэл <IconArrowRight size={12} />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  const clearData = () => {
    setShowModal(false);
    setDescription("");
    setSelectedData(null);
  };

  const submitHandler = async () => {
    if (selectedData?.id && description) {
      const res = await api.cancel_sms(selectedData.id, {
        comment: description,
      });
      if (res.status === 200) {
        toast("Масс мессежийг цуцлалаа", "success");
        handleTableChange(pagination);
      } else {
        toast(res.data.message || "Алдаа гарлаа", "error");
      }
      clearData();
    }
  };

  return (
    <>
      <Flex vertical gap={"15px"}>
        <Table
          columns={columns}
          dataSource={data}
          rowKey="id"
          loading={loading}
          pagination={pagination}
          onChange={handleTableChange}
        />
      </Flex>

      <CustomModal
        open={showModal}
        onCancel={clearData}
        title={"Масс мессеж цуцлах"}
        onOk={submitHandler}
        disabled={!description}
      >
        <Flex vertical gap={"10px"}>
          <Flex
            style={{
              backgroundColor: "#fff6cc",
              padding: "15px",
              borderRadius: "4px",
            }}
            align="center"
            gap={"10px"}
          >
            <IconAlertSquareRounded
              strokeWidth={1.5}
              color="#5f5c73"
              style={{
                width: "20px",
                height: "20px",
                padding: 0,
                margin: 0,
                flexShrink: 0,
              }}
            />

            <p style={{ color: "#5f5c73", textAlign: "justify" }}>
              Масс мессеж{" "}
              <span style={{ color: "#000", fontWeight: 600 }}>“Цуцласан”</span>{" "}
              төлөвт шилжүүлэх гэж байна. Энэ үйлдлийг буцаах боломжгүй тул
              сайтар нягтална уу.
            </p>
          </Flex>
          <CustomTextarea
            required
            title={"Тайлбар"}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Flex>
      </CustomModal>
    </>
  );
};

export default MassSmsTable;
